import * as CryptoJS from "crypto-js";
import Moment from "moment";
import { decrypt, encrypt } from "./Crypto";
import { decryptV2, encryptV2 } from "./CryptoV2";

// let key = CryptoJS.enc.Utf8.parse(Moment().format("DDMMYYYY"));
// let iv = CryptoJS.enc.Utf8.parse(Moment().format("YYYYMMDD"));

export async function Encrypt(value) {
  return await encryptV2(value);
  // let encrypted = CryptoJS.AES.encrypt(value, key, {
  //   keySize: 256 / 8,

  //   iv: iv,

  //   mode: CryptoJS.mode.CBC,

  //   padding: CryptoJS.pad.Pkcs7,
  // }).toString();

  // let decryptedText = encrypted.toString();

  // return decryptedText;
}

export async function Decrypt(value) {
  const decryptedWordArray = CryptoJS.AES.decrypt(value, "");
  const decryptedString = await decryptedWordArray.toString(CryptoJS.enc.Utf8);
  return decryptedString;
}

export async function Decrypt2(encData) {
  return await decryptV2(encData);
  // let decryptedBytes;
  // let decryptedText;

  // decryptedBytes = CryptoJS.AES.decrypt(encData, key, {
  //   keySize: 256 / 8,
  //   iv: iv,
  //   mode: CryptoJS.mode.CBC,
  //   padding: CryptoJS.pad.Pkcs7,
  // });
  // decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);
  // return decryptedText;
}

export async function Decrypt3(encData) {
  return await decrypt(encData);
}
export default Decrypt2;
